module.exports = __webpack_public_path__ + "src/assets/img/logo.72fde38d.svg";